module.exports = __webpack_public_path__ + "static/media/Sketch2_color.a109a4af.jpg";